// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"55772ded","241":"76afa92a","245":"c218ebca","334":"0ad69749","950":"04dccfc6"}[chunkId] + ".chunk.js";
};